import React, { useState } from "react";
import PropTypes from "prop-types";
import { Alert, Button, Modal, TextInput } from "@opendate-app/setlist";
import { useStaffingDepartmentsContext } from "./StaffingDepartmentsContext";
import ColorSwatches from "./ColorSwatches";

const DepartmentModal = ({ department, onClose }) => {
  const { paths, mutate } = useStaffingDepartmentsContext();
  const isNew = !department.id;
  const [name, setName] = useState(department.name || "");
  const [colorHex, setColorHex] = useState(department.color_hex || "");
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);
  const canSubmit = name.trim().length > 0 && !saving;

  const save = async () => {
    if (!canSubmit) return;
    setSaving(true);
    const body = { staff_department: { name, color_hex: colorHex || null } };
    const result = isNew
      ? await mutate("post", paths.departments, body, "Could not add this department.")
      : await mutate("patch", `${paths.departments}/${department.id}`, body, "Could not save this department.");
    setSaving(false);
    if (result.ok) {
      onClose();
    } else {
      setErrors(result.errors);
    }
  };

  return (
    <Modal
      open
      size="sm"
      title={isNew ? "Add a department" : "Edit department"}
      onClose={onClose}
      footer={
        <div className="d-flex justify-content-end w-100" style={{ gap: 8 }}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" disabled={!canSubmit} onClick={save}>
            {saving ? "Saving…" : "Save"}
          </Button>
        </div>
      }
    >
      {errors.length > 0 && (
        <div className="mb-3">
          <Alert color="error" title="Could not save" description={errors.join(" ")} />
        </div>
      )}
      <div className="mb-3">
        <TextInput id="staff-department-name" label="Name" required value={name} onChange={(event) => setName(event.target.value)} />
      </div>
      <ColorSwatches id="staff-department-color" label="Color" value={colorHex} onChange={setColorHex} />
    </Modal>
  );
};

DepartmentModal.propTypes = {
  department: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    color_hex: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DepartmentModal;
